var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            " " + _vm._s(_vm.$t("BusinessAfterCsgReturn.damageTitleText")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("backText")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.tryCancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      [
        _c(
          "el-row",
          { attrs: { gutter: 10 } },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessAfterCsgReturn.main.totalQty"),
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            disabled: "",
                            type: "text",
                            autosize: "",
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.planQty,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "planQty", $$v)
                            },
                            expression: "form.planQty",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseOrderDetail.table.associatedCode"
                          ),
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            type: "text",
                            disabled: "",
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.thirdCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "thirdCode", $$v)
                            },
                            expression: "form.thirdCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessAfterCsgReturn.table.reference"
                          ),
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            disabled: "",
                            type: "textarea",
                            "show-word-limit": "",
                            autosize: "",
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "remark", $$v)
                            },
                            expression: "form.remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessAfterCsgReturn.main.orderStatus"
                          ),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "option-list": _vm.RETURN_ORDER_STATUS },
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 3 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessAfterCsgReturn.main.backInventoryQty"
                          ),
                          prop: "backInventoryQty",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          staticClass: "full-width",
                          attrs: { clearable: "", controls: false },
                          model: {
                            value: _vm.form.backInventoryQty,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "backInventoryQty", $$v)
                            },
                            expression: "form.backInventoryQty",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 9 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessAfterCsgReturn.main.backInventoryRemark"
                          ),
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            type: "textarea",
                            "show-word-limit": "",
                            autosize: "",
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.backInventoryRemark,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "backInventoryRemark", $$v)
                            },
                            expression: "form.backInventoryRemark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 3 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessAfterCsgReturn.main.damagedQty"
                          ),
                          prop: "damagedQty",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          staticClass: "full-width",
                          attrs: { clearable: "", controls: false },
                          model: {
                            value: _vm.form.damagedQty,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "damagedQty", $$v)
                            },
                            expression: "form.damagedQty",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 9 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessAfterCsgReturn.main.damagedRemark"
                          ),
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            type: "textarea",
                            "show-word-limit": "",
                            autosize: "",
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.damagedRemark,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "damagedRemark", $$v)
                            },
                            expression: "form.damagedRemark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-row"),
          ],
          1
        ),
      ],
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Product")) + " "),
      ]),
      _c(
        "div",
        {
          staticClass: "bj-col bj-col-24",
          staticStyle: { "border-left": "none" },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: [_vm.form],
                border: "",
                script: "",
                "max-height": "600px",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "standardSkuCode",
                  label: "SKU",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "barCode",
                  label: _vm.$t("BusinessPurchaseDetailPage.table.Barcode"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "planQty",
                  label: _vm.$t("goodsSku.detail.qty"),
                  align: "center",
                },
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "skuStatus",
                    label: _vm.$t("BusinessAfterCsgReturn.table.skuStatus"),
                    align: "center",
                  },
                },
                [
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          _vm.RETURN_PRODUCT_STATUS.bjGet(_vm.form.skuStatus)
                        )
                      )
                    ),
                  ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("BusinessAfterCsgReturn.pictureMsg"))),
      ]),
      _c("div", { staticClass: "mt20" }, [
        _c(
          "div",
          { staticClass: "flex" },
          _vm._l(
            _vm.form.thirdPartyReturnOrderMaterialList,
            function (imageUrl, index) {
              return _c(
                "div",
                { key: index, staticClass: "imageViewer" },
                [
                  _c("BjKeyImage", {
                    staticStyle: { margin: "10px" },
                    attrs: {
                      height: "148px",
                      width: "148px",
                      url: imageUrl.detailImage,
                      preview: "",
                    },
                  }),
                  _c("div", { staticClass: "flex flex-spacearound" }, [
                    _c("i", {
                      staticClass: "el-icon-download yellow",
                      on: {
                        click: function ($event) {
                          return _vm.downloadImage(imageUrl.detailImage)
                        },
                      },
                    }),
                    _c("i", {
                      staticClass: "el-icon-delete red",
                      on: {
                        click: function ($event) {
                          return _vm.deleteImage(imageUrl.detailImage)
                        },
                      },
                    }),
                  ]),
                ],
                1
              )
            }
          ),
          0
        ),
      ]),
      _c("BjDivider", [
        _vm._v(
          _vm._s(_vm.$t("InternalReturnRefundNoteDetails.Upload")) +
            _vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Picture"))
        ),
      ]),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { display: "block", height: "100%" },
              attrs: { label: "" },
            },
            [
              _c(
                "BjUpload",
                {
                  ref: "BjUpload",
                  staticClass: "avatar-uploader",
                  attrs: {
                    limit: 20,
                    "limit-size": 5 * 1024,
                    multiple: "",
                    "show-file-list": "",
                    "list-type": "picture-card",
                    accept: "image/png,image/jpeg",
                    "accept-list": ["image/jpeg", "image/png"],
                    "auto-upload": "",
                    "limit-hide": "",
                  },
                  on: { afterUpload: _vm.afterUpload, remove: _vm.onRemoveUrl },
                },
                [
                  _c("template", { slot: "default" }, [
                    _c("i", {
                      staticClass: "el-icon-plus avatar-uploader-icon",
                    }),
                  ]),
                  _c("template", { slot: "tip" }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }